/* eslint-disable import/no-cycle */
import {
  fragment,
  params,
  shape,
  string,
  arrayOf,
  extend
} from '@thd-nucleus/data-sources';

const plccPromotionDataModel = shape({
  id: string(),
  offer: string(),
  deferredDisclosure: string(),
});

const dateRange = shape({
  id: string(),
  startDate: string(),
  endDate: string()
});

const plccDrawerModel = fragment().shape({
  id: string(),
  title: string(),
  componentName: string(),
  newAccountOfferDisclosure: string(),
  paymentEstimatorTila: string(),
  standardTila: string(),
  everydayPromotion: plccPromotionDataModel,
  appliancePromotion: plccPromotionDataModel,
  tieredPromotion: plccPromotionDataModel,
  twelveMonthPromotion: plccPromotionDataModel,
  tieredAppliancePromotion: plccPromotionDataModel,
  __typename: string()
});

const plccPromoInfo = fragment().shape({
  componentName: string(),
  id: string(),
  everydayDfp: string(),
  applianceDfp: string(),
  tieredDfp: string(),
  twelveMonthsSpecialDfp: string(),
  tieredApplianceDfp: string(),
  crcDfp: string(),
  appliancePromoDates: arrayOf(dateRange),
  tieredPromoDates: arrayOf(dateRange),
  twelveMonthSpecialPromoDates: arrayOf(dateRange),
  tieredApplianceDates: arrayOf(dateRange),
  publishDate: string(),
});

export const PlccPromoInfoDataModel = extend({
  component: params({
    id: string().isRequired(),
  }).shape({
    PlccPromoInfo: plccPromoInfo
  }),
});

export const PlccDrawerContentDataModel = extend({
  component: params({
    id: string().isRequired(),
  }).shape({
    PlccDrawerContent: plccDrawerModel
  }),
});

// const { data: promoInfoData } = useDataModel('component', {
//     variables: {
//       id: '2mf1i1OmapsjB3PCzwGynI',
//     },
//     dataModel: PlccPromoInfoDataModel,
//   });